import { eyebrowClass } from './ui'

export default function ExampleTest() {
  return (
    <figure className="overflow-hidden rounded-xl border border-line bg-surface shadow-[0_16px_50px_-24px_#20392f40]">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-line bg-soft px-5 py-3">
        <span className={`${eyebrowClass} text-brand`}>From the workbench</span>
        <span className="rounded-full border border-line bg-surface px-2.5 py-1 text-[11px] text-muted">Example · future feature</span>
      </div>
      <div className="p-5 sm:p-7">
        <p className={`${eyebrowClass} text-muted`}>One question. A fair test.</p>
        <h2 className="mt-3 font-serif text-2xl leading-tight">Could a different shaft<br className="hidden sm:block" /> tighten my dispersion?</h2>
        <div className="mt-5 rounded-lg border border-line bg-paper p-3">
          <svg viewBox="0 0 340 180" className="w-full" aria-hidden="true">
            <g stroke="#d8ddd3" strokeWidth="1">
              {[30, 70, 110, 150].map(y => <path key={y} d={`M15 ${y}H325`} />)}
              {[50, 110, 170, 230, 290].map(x => <path key={x} d={`M${x} 10V170`} />)}
            </g>
            <path d="M170 8V174" stroke="#58665e" strokeDasharray="4 5" />
            <ellipse cx="187" cy="88" rx="90" ry="61" fill="#ddd6c5" fillOpacity=".4" stroke="#897754" strokeDasharray="5 4" />
            <ellipse cx="170" cy="94" rx="59" ry="54" fill="#214f3b" fillOpacity=".08" stroke="#214f3b" />
            {[[107,72],[151,42],[239,77],[211,128],[171,99],[259,115],[211,55],[136,121]].map(([x,y], i) => <circle key={i} cx={x} cy={y} r="3.5" fill="#897754" />)}
            {[[130,82],[175,54],[204,84],[187,119],[157,110],[151,65],[195,104],[161,136]].map(([x,y], i) => <path key={i} d={`M${x-3} ${y-3}l6 6m0-6l-6 6`} stroke="#214f3b" strokeWidth="2" />)}
          </svg>
          <div className="flex justify-center gap-5 text-xs text-muted">
            <span><span aria-hidden="true" className="mr-1 text-[#897754]">●</span> Current shaft</span>
            <span><span aria-hidden="true" className="mr-1 text-brand">×</span> Test shaft</span>
          </div>
        </div>
        <figcaption className="mt-2 text-center text-[11px] text-muted">Illustrative dispersion · not measured shots</figcaption>
        <div className="mt-5 border-t border-line pt-4">
          <p className={`${eyebrowClass} text-brand`}>The question behind the numbers</p>
          <p className="mt-2 text-sm leading-relaxed text-muted">A tighter group, or normal variation? Repeat the test before calling it an improvement.</p>
        </div>
      </div>
    </figure>
  )
}
